var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"nwHuov"}},[_c('v-main',[_c('v-container',{attrs:{"fluid":""}})],1),_c('navBar',{attrs:{"title":"Ares - Main menu","home":true,"accolist":false,"type":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }